import { toNDigits } from '@mail/cross-sizes-utils';

class AiPhotoGenerationImageHelper {
    data: Uint8Array | null = null;

    saveImageData = (data: Uint8Array) => {
        this.data = data;
    };

    resetImageData = () => {
        this.data = null;
    };

    getImageData = () => this.data;

    getImageSize = () => {
        if (!this.data) {
            return null;
        }

        return toNDigits({ bytes: this.data.byteLength, maxDigitsCount: 3 });
    };
}

export const aiPhotoGenerationImageHelper = new AiPhotoGenerationImageHelper();
